import styled from "styled-components";
import { StyledGridProps } from "./Grid.types";
import { alignItems, flexDirection, justifyContent } from "styled-system";
import { Unit } from "../../../types/globals";

const StyledGrid = styled.div<StyledGridProps>`
	position: relative;
	display: flex;
	flex-wrap: wrap;
	${alignItems}
	${flexDirection}
  ${justifyContent}
  
  ${({ colGutters, rowGutters, theme, ...props }) => {
		const colGutterUnit = theme.space[colGutters];
		const rowGutterUnit = theme.space[rowGutters];

		const fitValue = (value: Unit) => {
			return props.fit ? `calc(100% + ${value})` : "auto";
		};

		return {
			width: fitValue(colGutterUnit),
			height: fitValue(rowGutterUnit),

			/*
        !important is needed until we can remove the temp reset in the Page
        component styles. Also see comment in preview-head.html.
      */
			marginTop: `-${rowGutterUnit}!important`,
			marginLeft: `-${colGutterUnit}!important`,

			"> .GridColumn": {
				paddingTop: rowGutterUnit,
				paddingLeft: colGutterUnit,
			},
		};
	}}
`;

export default StyledGrid;
